import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth/index';
import cartApi from 'api/cartApi';

const initialState = {
  cartCount: 0,
  favouriteCount: 0,
  loggedCartCount: 0,
  wishListCount: 0,
  courseUnitList: [],
  courseCartUnit: undefined,
  isCourseWishlist: undefined,
  paymentPage: false,
  error: undefined,
};

const cartSlice = createSlice({
  name: 'carts',
  initialState,
  reducers: {
    setLoggedCartCount: (state, action) => {
      state.loggedCartCount = action.payload;
    },
    setWishListCount: (state, action) => {
      state.wishListCount = action.payload;
    },
    setPaymentPage: (state, action) => {
      state.paymentPage = action.payload;
    },
    setCourseCartUnit: (state, action) => {
      state.courseCartUnit = action.payload;
    },
    setCourseUnitList: (state, action) => {
      state.courseUnitList = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const getLoggedCartCount = (state) => state.carts.loggedCartCount;
export const getWishListCount = (state) => state.carts.wishListCount;
export const getPaymentPage = (state) => state.carts.paymentPage;
export const getCourseCartUnit = (state) => state.carts.courseCartUnit;
export const getCourseUnitList = (state) => state.carts.courseUnitList;

export const setCourseUnitListAsync = (courseId) => async (dispatch) => {
  if (courseId) {
    const response = await cartApi.getUnitByIntake(courseId);
    return dispatch(setCourseUnitList(response));
  }
};

export const setCourseCartUnitAsync =
  (userId, courseId) => async (dispatch) => {
    if (userId) {
      if ((userId, courseId)) {
        const response = await cartApi.getCartDetailByUser(userId);
        let cartItem = [];
        dispatch(setCourseCartUnit(undefined));
        if (response?.length) {
          response?.map((data, i) => {
            if (data?.course?._id === courseId) {
              cartItem = data?.units;
            }
          });
          return dispatch(setCourseCartUnit(cartItem));
        }
      }
    } else {
      let cart =
        localStorage.getItem('cartItem') !== null &&
        localStorage.getItem('cartItem') !== ''
          ? JSON.parse(localStorage.getItem('cartItem'))
          : [];
      if (cart?.length) {
        let cartItem = [];
        dispatch(setCourseCartUnit(undefined));
        cart.map((dt) => {
          if (dt?._id === courseId) {
            cartItem = dt?.unitArray;
          }
        });
        return dispatch(setCourseCartUnit(cartItem));
      }
    }
  };

export const getCartCountAsync = (id) => async (dispatch) => {
  if (id) {
    const response = await cartApi.getCartDetailByUser(id);
    return dispatch(
      setLoggedCartCount(response?.length > 0 ? response?.length : 0),
    );
  } else {
    const storedCartArray = localStorage.getItem('cartItem');
    const cartArray = storedCartArray ? JSON.parse(storedCartArray) : [];
    return dispatch(setLoggedCartCount(cartArray?.length));
  }
};

export const getWishListAsync = (id, courseId) => async (dispatch) => {
  if (id) {
    const response = await cartApi.getWishListByUserId(id);
    return dispatch(
      setWishListCount(response?.length > 0 ? response?.length : 0),
    );
  } else {
    const storedFavArray = localStorage.getItem('wishList');
    const favArray = storedFavArray ? JSON.parse(storedFavArray) : [];
    return dispatch(setWishListCount(favArray?.length));
  }
};

export const {
  setLoggedCartCount,
  setWishListCount,
  setPaymentPage,
  setCourseCartUnit,
  setCourseUnitList,
} = cartSlice.actions;

export default cartSlice.reducer;
